import {NewProduct, NewProductDTO} from '../models/Form'
import {Observable} from 'rxjs'
import {Query} from '../../../common/api/Query'
import {ItemList} from '../../../common/models/ItemList'
import {Container, IInit} from '../../../common/container/Container'
import {IStatusService} from '../../../common/status/StatusService'
import {IFormApi} from '../api/FormApi'
import {STATUS_SERVICE_KEY} from '../../../container/app'
import {ProductDTO} from "../../product/models/ProductDTO";

type Props = {
    apiKey: symbol
}

export interface IFormService extends IInit {
    getByID(id: string): Observable<NewProduct | undefined>
    byTypeForm(typeForm: string): Observable<NewProduct | undefined>
    add(e: NewProductDTO): Observable<NewProduct | undefined>
    list(): Observable<NewProduct[]>
    update(id: string, e: NewProductDTO): Observable<NewProduct | undefined>
}

export class FormService implements IFormService {
    private readonly _apiKey: symbol
    private _container!: Container
    private _api!: IFormApi
    private _statusService!: IStatusService

    constructor(p: Props) {
        this._apiKey = p.apiKey
    }

    init(c: Container) {
        this._container = c
        this._api = this._container.get<IFormApi>(this._apiKey)
        this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
    }

    getByID(id: string): Observable<NewProduct | undefined> {
        return this._api.getByID(id)
    }

    byTypeForm(typeForm: string): Observable<NewProduct | undefined> {
        return this._api.byTypeForm(typeForm)
    }

    add(e: NewProductDTO): Observable<NewProduct | undefined> {
        return this._api.add(e)
    }

    list(): Observable<NewProduct[]> {
        return this._api.list()
    }

    update(id: string, e: NewProductDTO): Observable<NewProduct | undefined> {
        return this._api.update(id, e)
    }

}
